var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Card, Flex } from 'pcln-design-system';
import styled from 'styled-components';
import { PricelineSparkle } from 'pcln-icons';
var CardImage = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 32px;\n  min-height: 32px;\n  border: none;\n  box-shadow: 0px -1.29266px 0px rgba(0, 0, 0, 0.03), 0px 0px 1.29266px rgba(0, 0, 0, 0.24),\n    0px 1.29266px 1.29266px rgba(0, 0, 0, 0.16), 0px 2.58533px 5.17065px rgba(0, 0, 0, 0.12);\n"], ["\n  min-width: 32px;\n  min-height: 32px;\n  border: none;\n  box-shadow: 0px -1.29266px 0px rgba(0, 0, 0, 0.03), 0px 0px 1.29266px rgba(0, 0, 0, 0.24),\n    0px 1.29266px 1.29266px rgba(0, 0, 0, 0.16), 0px 2.58533px 5.17065px rgba(0, 0, 0, 0.12);\n"
    /**
     * TravelBotAvatar Component
     * @public
     */
])));
/**
 * TravelBotAvatar Component
 * @public
 */
export var TravelBotAvatar = function () {
    return (React.createElement(CardImage, { borderRadius: 50, width: '32px', height: '32px' },
        React.createElement(Flex, { width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', bg: 'primary.base', style: { borderRadius: '100%' } },
            React.createElement(PricelineSparkle, { size: 24, color: 'text.lightest', style: { margin: 'auto' } }))));
};
var templateObject_1;
//# sourceMappingURL=TravelBotAvatar.js.map